export const GET_LOGIN_USER = "GET_LOGIN_USER";
export const GET_LOGIN_USER_ERROR = "GET_LOGIN_USER_ERROR";
export const GET_SIGNUP_USER = "GET_SIGNUP_USER";
export const GET_SIGNUP_USER_ERROR = "GET_SIGNUP_USER_ERROR";
export const GET_LOGOUT_USER = "GET_LOGOUT_USER";
export const GET_LOGIN_USER_LOADING="GET_LOGIN_USER_LOADING";
export const SET_LOGIN_USER_LOADING="SET_LOGIN_USER_LOADING";